import {instantMillis,timezoneSafeTimestamp} from '../core/time.js';
export {createClockIntegrityMonitor} from '../core/time.js';

function requiredTimestamp(value,label){
  const text=timezoneSafeTimestamp(value,label);
  return Object.freeze({iso:text,millis:Date.parse(text)});
}

function optionalTimestamp(value,label){
  if(value==null||value==='')return null;
  return requiredTimestamp(value,label);
}

export function clockValue(now){
  const raw=typeof now==='function'?now():now;
  if(raw instanceof Date){
    if(Number.isNaN(raw.getTime()))throw new TypeError('now is invalid');
    return raw.getTime();
  }
  if(typeof raw==='number'){
    if(!Number.isFinite(raw))throw new TypeError('now is invalid');
    return raw;
  }
  return instantMillis(raw,'now');
}

function plannedMillis(stageTarget){
  const value=stageTarget?.plannedDurationMinutes;
  if(value==null||value==='')return null;
  const minutes=Number(value);
  if(!Number.isInteger(minutes)||minutes<1)throw new TypeError('plannedDurationMinutes must be a positive integer');
  return minutes*60_000;
}

function durationState(startMillis,nowMillis,plannedMs){
  const elapsedMs=Math.max(0,nowMillis-startMillis);
  const remainingMs=plannedMs==null?null:Math.max(0,plannedMs-elapsedMs);
  const overdueMs=plannedMs==null?null:Math.max(0,elapsedMs-plannedMs);
  return Object.freeze({
    elapsedMs,
    elapsedSeconds:Math.floor(elapsedMs/1000),
    elapsedMinutes:Math.floor(elapsedMs/60_000),
    plannedMs,
    plannedMinutes:plannedMs==null?null:plannedMs/60_000,
    remainingMs,
    remainingSeconds:remainingMs==null?null:Math.ceil(remainingMs/1000),
    overdueMs,
    overdue:overdueMs!=null&&overdueMs>0,
    complete:plannedMs!=null&&remainingMs===0
  });
}

export function craftTimerSnapshot({startedAt,activeStageId,stageStartedAt,plannedDurationMinutes=null,now=Date.now}={}){
  const sessionStart=requiredTimestamp(startedAt,'startedAt');
  const stageStart=requiredTimestamp(stageStartedAt,'stageStartedAt');
  if(!String(activeStageId||'').trim())throw new TypeError('activeStageId is required');
  if(stageStart.millis<sessionStart.millis)throw new TypeError('stageStartedAt cannot be before startedAt');
  const current=clockValue(now);
  const planned=plannedMillis({plannedDurationMinutes});
  return Object.freeze({
    capturedAt:new Date(current).toISOString(),activeStageId:String(activeStageId),
    session:durationState(sessionStart.millis,current,null),
    stage:durationState(stageStart.millis,current,planned),
    source:Object.freeze({startedAt:sessionStart.iso,stageStartedAt:stageStart.iso,plannedDurationMinutes:planned==null?null:planned/60_000})
  });
}
